import axios from "axios";
import { apiPath,apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken")
let config = {
  headers: {
    'Authorization': 'Bearer ' + token
  }
}
const state = {
  isLoadRooms: false,
  isLoadChambre: false,
  errorChambre: "",
  rooms: [],
  roomsSearchResult: null,
  conversationsChambre: null,
};

const getters = {
  isLoadRooms: state => state.isLoadRooms,
  isLoadChambre: state => state.isLoadChambre,
  errorChambre: state => state.errorChambre,
  rooms: state => state.rooms,
};

const mutations = {
  getRoomsSuccess(state, payload) {
    state.isLoadRooms = true;
    state.rooms = payload.rooms;
  },
  addRoomSuccess(state, payload) {
    state.isLoadRooms = true;
    let rooms = state.rooms;
    rooms.push(payload.data);
    state.rooms = rooms;
  },
  editRoomSuccess(state, payload) {
    state.isLoadRooms = true;
    let rooms = state.rooms;

    let newRooms = [];
    rooms.map((room,index)=>{
      if(room._id==payload.data._id){
        newRooms.push({...payload.data})
      }else{
        newRooms.push({...room})
      }
    });
    
    state.rooms = [...newRooms];
  },
  deleteRoomSuccess(state, payload) {
    state.isLoadRooms = true;
    let rooms = state.rooms;

    let newRooms = [];
    rooms.map((room,index)=>{
      if(room._id!=payload.data._id){
        newRooms.push({...room})
      }
    });
    state.rooms = [...newRooms];
  },
  addClientTTSuccess(state, payload) {
    state.isLoadRooms = true;
   
  },
  getRoomsError(state, error) {
    state.isLoadRooms = false;
    state.errorChambre = error;
  },
  addRoomError(state, error) {
    state.isLoadRooms = false;
    state.errorChambre = error;
  }
};

const actions = {
  getRooms({ commit }) {
    token = localStorage.getItem("accessToken")
    config = {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }
    axios
      .get(`${apiPath}/rooms`,config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getRoomsSuccess", {
            rooms: res.data
          });
        } else {
          commit("getRoomsError", "error:getRooms");
        }
      });
  },
  addRoom({ commit }, payload) {
    
    
    return axios
      .post(`${apiPath}/rooms`, payload,config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addRoomSuccess", res);
        } else {
          commit("addRoomError", "error:addRoom");
        }
        return res;
      });
  },
  editRoom({ commit }, payload) {
    return axios
      .post(`${apiPath}/rooms/${payload._id}`, payload,config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("editRoomSuccess", res);
        } else {
          commit("addRoomError", "error:addRoom");
        }
        return res;
      });
  },
  SyncChambre({ commit }, payload,config) {
      axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/definition`)
      .then(r => r.data)
      .then(res => {
      });
      axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/price`)
      .then(r => r.data)
      .then(res => {
      });

      axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/master`)
      .then(r => r.data)
      .then(res => {
      });

      axios
      .post(`${apiPath1}/sync/${payload._id}/get/menu/class`)
      .then(r => r.data)
      .then(res => {
      });
      axios
      .post(`${apiPath1}/sync/${payload._id}/get/family/group`)
      .then(r => r.data)
      .then(res => {
      });
  },

  deleteRoom({ commit }, payload,config) {
    return axios
      .delete(`${apiPath}/rooms/${payload._id}`)
      .then(r => r.data)
      .then(res => {
        // if (res.ok) {
        //   commit("deleteRoomSuccess", payload);
        // } else {
        //   commit("addRoomError", "error:addRoom");
        // }
        return payload;
      });
  },
  createClient({ commit }, payload) {
    return axios
      .post(`${apiPath}/create/client`, payload)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addClientTTSuccess", res);
        } else {
        }
        return res;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
